@if (errorMessage) {
  <div class="alert alert-danger">{{errorMessage}}</div>
}
<header>
  <nav class="navbar navbar-expand-sm navbar-expand navbar-dark fixed-top bg-dark">
    @if (branding) {
      <div class="navbar-brand">
        <img class="logo pull-left" [src]="branding.logoUrl" />
        <span class="title">{{ branding.title }}</span>
        <span class="subtitle">{{ branding.subTitle }}</span>
      </div>
    }
    @if (isLoggedIn) {
      <button class="navbar-toggler" type="button" (click)="toggleNavbar()" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    }
    @if (isLoggedIn) {
      <div [ngbCollapse]="isNavbarCollapsed" class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item dropdown" ngbDropdown>
            <button class="btn btn-primary dropdown-toggle" id="navbarDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-user" style="width: 15px;"></i> {{displayName}}
            </button>
            <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="navbarDropdown">
              @if (showSecAdminLink) {
                <a class="dropdown-item" href="{{secAdminLink}}" target="_blank"><i class="fa fa-lock" style="width: 20px;"></i>Security Administration</a>
              }
              <a class="dropdown-item" href="/identity/account/Manage/ChangePassword"><i class="fa fa-key" style="width: 17px;"></i> Change Password</a>
              <a class="dropdown-item" href="/identity/account/logout?returnUrl=%2F"><i class="fa fa-sign-out" style="width: 17px;"></i> Sign Out</a>
            </div>
          </li>
        </ul>
      </div>
    }
  </nav>
</header>
